export const WWEX_API_CODE = 'speedship' as const;
export const UNISHIPPERS_API_CODE = 'unishippers' as const;
